module.exports = __webpack_public_path__ + "static/media/0268_Small.8a2fb22f.jpg";